import { useUrlSearchParams } from "@vueuse/core";

export function useAuthLoginForm() {
  const { redirect } = useUrlSearchParams<{ redirect?: string }>();
  return useFormHandler<{ message: string }>({
    schema: authLoginSchema,
    action: "auth_login",
    initialValues: { remember: false },
    onSuccess: () => location.href = redirect || "/",
  });
};

export function useAuthForgotPasswordForm() {
  return useFormHandler<{ message: string }>({
    schema: authForgotPasswordSchema,
    action: "auth_forgot_password",
  });
}

export function useAuthResetPasswordForm() {
  return useFormHandler<{ message: string }>({
    schema: authResetPasswordSchema,
    action: "auth_reset_password",
    onSuccess: () => location.href = "/mon-compte",
  });
}

export function useAuthRegisterForm() {
  return useFormHandler<{ message: string }>({
    schema: authRegisterSchema,
    action: "auth_register",
  });
}

export function useAuthLogoutForm() {
  const { redirect } = useUrlSearchParams<{ redirect?: string }>();
  return useFormHandler<{ message: string }>({
    schema: v.object({}),
    action: "auth_logout",
    onSuccess: () => location.href = redirect || "/",
  });
}
